import tinycolor from 'tinycolor2';

export const isTooLight = (color) => tinycolor(color).getLuminance() >= 0.8;

export default isTooLight;
